export const INVITE = {
    root: 'invite-page',
    loading: 'invite-loading',
    notFound: 'invite-not-found',
    tripName: 'invite-trip-name',
    tripDestination: 'invite-trip-destination',
    tripDates: 'invite-trip-dates',
    ownerName: 'invite-owner-name',
    acceptButton: 'invite-accept-button',
    declineButton: 'invite-decline-button',
    alreadyMember: 'invite-already-member',
};

export const TRIP_SETTINGS = {
    openButton: 'trip-settings-open-button',
    dialog: 'trip-settings-dialog',
    shareButton: 'trip-share-button',
    participantRow: 'trip-participant-row',
    removeParticipantButton: 'trip-remove-participant-button',
    confirmRemoveButton: 'trip-confirm-remove-button',
    ownerCrown: 'trip-owner-crown',
};

export const TRIP_STATUS = {
    container: 'trip-status-container',
    ideasCount: 'trip-status-ideas-count',
    preferencesCount: 'trip-status-preferences-count',
    votesCount: 'trip-status-votes-count',
};
